// extracted by mini-css-extract-plugin
export default {"profileBar":"ProfileBar-module__profileBar--hyi0q"};